export const firebaseConfig = {
  apiKey: "AIzaSyDy8yi289XDLz_WkYTIRCewmO6QGLeIxl0",
  authDomain: "leysin-mosses-lecherette.firebaseapp.com",
  projectId: "leysin-mosses-lecherette",
  storageBucket: "leysin-mosses-lecherette.firebasestorage.app",
  messagingSenderId: "832035853391",
  appId: "1:832035853391:web:917b4aa26160e02c37863a",
  measurementId: "G-C6LENQVM9D"
};

export const enabled = true;
export const skitude_api_url = "https://publicapi.skitude.com";
export const skitude_api_key = "vTO5VPmXJq3CKvd1mR4Dl1iisLTbGjjT5hiXEZVa";
export const skitude_app_token = "zBCMlghRY65TgGC7zhofs6JCkGtcp90p1m8Iqgl3";

const sso = {
   enabled,
   firebaseConfig,
   skitude_api_url,
   skitude_api_key,
   skitude_app_token,
};

export default sso;